import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../group/groupselect.component';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoFileService} from '../../../service/info/service-thongbaofile';
import {Sessioncommand} from '../../../global/sessioncommand';
import {SelectStaffComponent} from '../../ui/selectstaff/selectstaff.component';
import {Router} from '@angular/router';
import {RolePermissionService} from '../../../service/security/service-rolepermission';
import {CkEditorUploadAdapter} from '../../../global/upload-ckeditor';

@Component({
  templateUrl: './create.component.html'

})
export class SoanThongBaoComponent implements OnInit, AfterViewInit {

  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public staffSelectList: Object[];
  public selectedList: Object[];
  public isStatus: boolean = false;
  public dateHieuLuc: Date = new Date();
  public dateHetHieuLuc: Date;
  private ckConfig= {
    uploadUrl:      'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',
  };
  constructor(  public thongBaoService: ThongBaoService,
                public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public thongBaoFileService: ThongBaoFileService,
                public datepipe: DatePipe,
                public bsModalService: BsModalService,
                public router: Router,
                public rolePermissionService: RolePermissionService

  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );

    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CkEditorUploadAdapter(loader);
    };
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }

  ngOnInit(): void {
    this.rolePermissionService.checkNavByCode(Sessioncommand.staffId, 'TBADD').subscribe( x => {
      if (x === false)
        this.rolePermissionService.redirectAccesDenied();
    });

    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      chuDe: new FormControl(),
      ngayHieuLuc: new FormControl(),
      noiDung: new FormControl(),
      ngayHetHieuLuc: new FormControl(),
      nguoiNhap:new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      chuDe: ['' , Validators.compose([validateEmpty]) ],
      ngayHieuLuc: ['', Validators.compose([validateEmpty])],
      noiDung: ['', Validators.nullValidator],
      ngayHetHieuLuc: ['', Validators.nullValidator],
      nguoiNhap: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.thongBaoFileService.urlUpload;
    this.deleteUrl= this.thongBaoFileService.urlDelete;
    this.staffSelectList = [];
    this.selectedList = [];


  }
  get f() { return this.frmGroup.controls; }

  public createItem ()
  {
    this.frmGroup.value.ngayHieuLuc = this.datepipe.transform(Date.parse(this.frmGroup.value.ngayHieuLuc), 'dd/MM/yyyy');;
    this.frmGroup.value.ngayHetHieuLuc = this.datepipe.transform(Date.parse(this.frmGroup.value.ngayHetHieuLuc), 'dd/MM/yyyy');;
    let arrStaff: string = this.uiSelectStaff.selected.join();
    this.frmGroup.value.nguoiNhap = Sessioncommand.staffId;
    this.thongBaoService.add(arrStaff, this.frmGroup.value).subscribe(
      {    next: (data) => {
          this.uploadFileComponent.id = data.id;
          this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
          this.toastr.success(language.add_success_record, language.message);
          Sessioncommand.notification = true;
          Sessioncommand.giaiQuyetSuVuStatus = 0;
          this.router.navigate(['/giaiquyetsuvu/qlsuvu'], {  queryParams: {  ty: 'tb' } });

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public showGroup()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
            this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedList= [...this.selectedList, result[i].id];
          }
        }
      }
    });
  }

  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
      this.createItem();

  }


}

